import ENDPOINT from '@/config/endpoint'
import request from '@/utils/request'
import { DEFAULT_PASSWORD_NOTION_TABLE } from '@/config/constants'

export async function fetchCurrentCountry() {
  return await request({
    url: `${ENDPOINT.BASE_API_URL}/resources/lang`,
    method: 'get',
  })
}

export async function fetchCountry(params) {
  return await request({
    url: `${ENDPOINT.BASE_API_URL}/resources/countries`,
    method: 'get',
    params,
  })
}

export async function fetchPasswordGeneratorApp() {
  return await request({
    url: `https://notion.cystack.workers.dev/v1/page/${DEFAULT_PASSWORD_NOTION_TABLE}`,
    method: 'get',
  })
}
